var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-flex",
            [
              _c("SectionAttachmentDetail", {
                attrs: {
                  breadCrumbs: _vm.breadCrumbs,
                  title: _vm.attachmentDetail.fileName,
                  toolbarActions: [
                    {
                      text: "Edit Attachment",
                      icon: "edit",
                      iconColor: "warning",
                      emitEvent: "onEditAttachmentClicked",
                    },
                    {
                      text: "Download",
                      icon: "get_app",
                      iconColor: "info",
                      emitEvent: "onDownloadClicked",
                    },
                  ],
                  attachmentDetail: _vm.attachmentDetail,
                  modelList: _vm.modelList,
                  manufacturerList: _vm.manufacturerList,
                  categoryList: _vm.categoryList,
                  activityTypeList: _vm.activityTypeList,
                  locationList: _vm.locationList,
                  clientList: _vm.clientList,
                  userList: _vm.userList,
                  isLoading: _vm.isLoading,
                },
                on: {
                  onClickBreadcrumb: (val) =>
                    _vm.$emit("onClickBreadcrumb", val),
                  onEditAttachmentClicked: function ($event) {
                    _vm.showDialogFormAttachmentEdit = true
                  },
                  onDownloadClicked: _vm.fetchAttachmentFile,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "v-tabs",
                {
                  attrs: { dark: "" },
                  model: {
                    value: _vm.currentTab,
                    callback: function ($$v) {
                      _vm.currentTab = $$v
                    },
                    expression: "currentTab",
                  },
                },
                [
                  _c(
                    "v-tab",
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("construction"),
                      ]),
                      _vm._v(
                        _vm._s(
                          `Equipment (${
                            (_vm.attachmentDetail.assetList &&
                              _vm.attachmentDetail.assetList.length) ||
                            0
                          })`
                        ) + "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab",
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("event")]),
                      _vm._v(
                        _vm._s(
                          `Activities (${
                            (_vm.attachmentDetail.activityList &&
                              _vm.attachmentDetail.activityList.length) ||
                            0
                          })`
                        ) + "\n        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.currentTab === _vm.tabAssets
            ? _c(
                "v-flex",
                [
                  _c("SectionAssetList", {
                    attrs: {
                      xs12: "",
                      isPrimary: false,
                      title: "Equipment",
                      shouldShowCheckBoxes: false,
                      assetList: _vm.attachmentDetail.assetList || [],
                      modelList: _vm.modelList,
                      manufacturerList: _vm.manufacturerList,
                      categoryList: _vm.categoryList,
                      activityTypeList: _vm.activityTypeList,
                      assetStatusList: _vm.assetStatusList,
                      locationList: _vm.locationList,
                      clientList: _vm.clientList,
                      userList: _vm.userList,
                      isLoading: _vm.isLoading,
                    },
                    on: {
                      onClickViewEquipment: (val) =>
                        _vm.$emit("onClickViewEquipmentFromAttachmentDetail", {
                          ...val,
                          breadCrumbTitle: _vm.attachmentDetail.fileName,
                        }),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === _vm.tabActivities
            ? _c(
                "v-flex",
                [
                  _c("SectionActivityList", {
                    attrs: {
                      xs12: "",
                      isPrimary: false,
                      title: "Activity",
                      activityList: _vm.attachmentDetail.activityList || [],
                      activityTypeList: _vm.activityTypeList,
                      assetStatusList: _vm.assetStatusList,
                      locationList: _vm.locationList,
                      userList: _vm.userList,
                      modelList: _vm.modelList,
                      isLoading: _vm.isLoading,
                    },
                    on: {
                      onClickViewActivity: (val) =>
                        _vm.$emit("onClickViewActivityFromAttachmentDetail", {
                          ...val,
                          breadCrumbTitle: _vm.attachmentDetail.fileName,
                        }),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("DialogFormAttachmentEdit", {
        attrs: {
          showDialog: _vm.showDialogFormAttachmentEdit,
          attachmentToEdit: _vm.attachmentDetail,
          activityTypeList: _vm.activityTypeList,
          userList: _vm.userList,
          locationList: _vm.locationList,
          modelList: _vm.modelList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormAttachmentEdit = false
          },
          onSubmitClicked: (val) => [
            _vm.onDialogFormAttachmentEditSubmit(val),
            (_vm.showDialogFormAttachmentEdit = false),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }